import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_IncomeList = _resolveComponent("IncomeList")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "income_list" }),
      _createVNode(_component_IncomeList, {
        incomes: _ctx.filteredIncomes,
        "search-query": _ctx.searchQuery,
        loading: _ctx.loading,
        "onUpdate:searchQuery": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchQuery = $event)),
        onDelete: _ctx.deleteIncome
      }, null, 8, ["incomes", "search-query", "loading", "onDelete"]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}